module.exports = __webpack_public_path__ + "files/2de58e1ab028beff8151b6f11e9767d6.svg";